import { HttpAuthGateway } from '@domain/auth/HttpAuthGateway';

export const authGateway = new HttpAuthGateway();
